import initReactApp from 'dpl/util/initReactApp';
import ReviewsPageLink from 'dpl/homepage/components/v2/ReviewsPageLink';
import BreedersByBreedSection from 'dpl/homepage/components/v2/BreedersByBreedSection';
import SheltersSection from 'dpl/homepage/components/v2/SheltersSection';
import FutureBreederVideosSection from 'dpl/homepage/components/v2/FutureBreederVideosSection';
import GoodDogHomeSection from 'dpl/homepage/components/v2/GoodDogHomeSection';
import MobileAppQRSection from 'dpl/homepage/components/v2/MobileAppQRSection';
import GoodDogNewsSection from 'dpl/homepage/components/v2/GoodDogNewsSection';
import BreedOverviewPagesFooterSection from 'dpl/homepage/components/v2/BreedOverviewPagesFooterSection';
import PopularBreedsFooterSection from 'dpl/homepage/components/v2/PopularBreedsFooterSection';
import PopularBreedCardSection from 'dpl/homepage/components/v2/PopularBreedCardSection';
import OwnerStoriesSection from 'dpl/homepage/components/v2/OwnerStoriesSection';
import HomepageSearchBar from 'dpl/homepage/components/v2/HomepageSearchBar';
import MobileHomepageSearchBar from 'dpl/homepage/components/v2/MobileHomepageSearchBar';
import LearningCenterArticleCardSection from 'dpl/homepage/components/v2/LearningCenterArticleCardSection';
import GoodDogStandardSectionButton from 'dpl/homepage/components/v2/GoodDogStandardSectionButton';
import { setAnalyticsOrigin } from 'dpl/shared/utils/setAnalyticsOrigin';
import { ANALYTICS_VIEWS } from 'dpl/constants/analytics';

setAnalyticsOrigin({
  originView: ANALYTICS_VIEWS.HOME
});

initReactApp({
  HomepageSearchBar,
  MobileHomepageSearchBar,
  ReviewsPageLink,
  BreedersByBreedSection,
  SheltersSection,
  FutureBreederVideosSection,
  OwnerStoriesSection,
  GoodDogHomeSection,
  MobileAppQRSection,
  GoodDogNewsSection,
  PopularBreedsFooterSection,
  PopularBreedCardSection,
  BreedOverviewPagesFooterSection,
  LearningCenterArticleCardSection,
  GoodDogStandardSectionButton
});
